import React from 'react';
import { HeaderBrand } from 'molecules';
import { HeaderActions } from 'molecules';

type HeaderBarProps = {
  logoSrc: string;
  wordmark?: string;
  wordmarkUppercase?: boolean;
  wordmarkSize?: string;
  logoHeight?: string;
  label: string;
  onOpenMenu?: () => void;
  isMenuOpen?: boolean;
  className?: string;
};

const HeaderBar: React.FC<HeaderBarProps> = ({
  logoSrc,
  wordmark,
  wordmarkUppercase,
  wordmarkSize,
  logoHeight,
  label,
  onOpenMenu,
  isMenuOpen,
  className,
}) => {
  return (
    <header className={className}>
      <div className="app-header-inner">
        <HeaderBrand
          logoSrc={logoSrc}
          wordmark={wordmark}
          wordmarkUppercase={wordmarkUppercase}
          wordmarkSize={wordmarkSize}
          logoHeight={logoHeight}
          label={label}
        />
        <HeaderActions onOpenMenu={onOpenMenu} isMenuOpen={isMenuOpen} />
      </div>
    </header>
  );
};

export default HeaderBar;
